import { color } from "minimum-ui/tokens";
import { rem } from "polished";
import styled from "styled-components";

const DL = styled.dl`
  display: grid;
  grid-template-columns: 1fr 2fr;
  grid-gap: 8px 0;
`;

const Term = styled.dt`
  margin: 0;
  padding: 16px;
  font-size: ${rem(14)};
  line-height: ${rem(24)};
  font-weight: 400;
  background: ${color.neutral[100]};
  color: ${color.neutral[400]};
`;

const Desc = styled(Term).attrs({ as: "dd" })`
  color: ${color.neutral[500]};
  text-align: right;
  font-weight: 600;
`;

export { Desc, Term };
export default DL;
